// eslint-disable-next-line no-restricted-imports
import { appWithTranslation, i18n, withTranslation, Trans } from 'next-i18next';

const availableLocales = ['en-GB', 'de-CH', 'it-IT', 'fr-FR', 'nl-NL', 'sv-SE'];
const defaultLanguage = 'en-GB';
const namespaces = ['translations'];

/**
 * Returns the translation for the given key, if it exists.
 * @param {string} key
 * @param {*} [options]
 * @returns {string}
 * @deprecated Use the `useTranslation` from '@framework/hooks/useTranslation' hook instead. Because we have no way of knowing if the translation is loaded and this will not be automatically updated if the translation is loaded.
 */
const optimisticTranslate = (key, options) => i18n?.t(key, options) ?? '';

export {
    appWithTranslation,
    availableLocales,
    defaultLanguage,
    i18n,
    namespaces,
    optimisticTranslate,
    withTranslation,
    Trans
};
